import { idOf } from './identity.js';

/**
 * A catalog item as the asset a lot row and the clerk console draw from.
 *
 * `GET /sales/:id/assets` answers catalog items in the feed's UPPERCASE names,
 * each with the `runNumber` the block shows. Every surface reads lowercase
 * names, so this is the one place they change. Lights stay color words
 * ('Red'); the surface that draws a letter code maps them itself.
 *
 * @param {Object} item A catalog item from the sale's assets.
 * @returns {{ id: string|null, runNumber: string, vin: string|null, year: number|null, make: string|null, model: string|null, trim: string|null, mileage: number|null, imageUrls: string[], lights: string[], mmr: number|null }}
 */
export function saleAssetOf(item) {
    return {
        id: idOf(item),
        runNumber: item?.runNumber ?? '',
        vin: item?.VIN ?? null,
        year: item?.YEAR ?? null,
        make: item?.MAKE ?? null,
        model: item?.MODEL ?? null,
        trim: item?.SERIES ?? null,
        mileage: item?.ODOMETERREADING ?? null,
        imageUrls: imageUrlsOf(item?.IMAGES),
        lights: lightColorsOf(item?.SALELIGHTS),
        mmr: mmrOf(item?.BOOKVALUE)
    };
}

function imageUrlsOf(images) {
    if (!Array.isArray(images)) return [];
    return images
        .filter((image) => typeof image?.URL === 'string' && image.URL.length > 0)
        .sort((a, b) => (a.POSITION ?? 0) - (b.POSITION ?? 0))
        .map((image) => image.URL);
}

function lightColorsOf(saleLights) {
    if (!Array.isArray(saleLights)) return [];
    return saleLights
        .map((light) => light?.COLOR)
        .filter((color) => typeof color === 'string' && color.length > 0);
}

// The feed sends BOOKVALUE as a string, and '0' means it has no estimate.
function mmrOf(bookValue) {
    const value = Number(bookValue);
    if (bookValue == null || !(value > 0)) return null;
    return value;
}

export default saleAssetOf;
